// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumbs":"Breadcrumbs_Breadcrumbs__CAtZm","Breadcrumbs__inner":"Breadcrumbs_Breadcrumbs__inner__A1U5o"};